import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AukceImage} from "../models/aukceImage";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  readonly URL_MAILJET_SEND = "https://ramus.je/tichaaukce/assets/sending.php" // the actual script is in assets/sending.php

  constructor(
    public http: HttpClient
  ) { }

  sendBylJsiPrehozenEmail(photo: AukceImage, prihoz: number, recipient: string) {
    // TODO nekam dat novej sending.php skript

    const body = new FormData();
    body.append('komutomamposlat', recipient)
    body.append('castka', prihoz.toString())
    body.append('fotka', photo as any)

    console.log('sent', body)

    return this.http.post(this.URL_MAILJET_SEND, body, { responseType: 'text' })
  }
}
